export const namespaced = true;

export const state = {
  filters: {},
  displayed: [],
  query: null,
};

export const mutations = {
  SET_FILTERS(state, data) {
    state.filters = data;
  },
  SET_QUERY(state, query) {
    state.query = query;
    let url = window.location.pathname;
    if (query) {
      url = url + "#" + query;
    }
    history.pushState({}, null, url);
  },
  SET_DISPLAYED(state, displayed) {
    state.displayed = displayed;
  },
  CLEAR_FILTERS(state) {
    state.filters = {};
    state.displayed = [];
    state.query = null;
  },
};

export const actions = {
  clearFilters({ commit }) {
    commit("CLEAR_FILTERS");
  },
  removeFilterByID({ commit, dispatch }, id) {
    let filters = state.filters;
    filters[id] = null;

    commit("SET_FILTERS", filters);
    sessionStorage.setItem("filters", JSON.stringify(filters));
    dispatch("setQueryDisplayed");
  },
  setFilters({ commit, dispatch }, filters) {
    commit("SET_FILTERS", filters);
    sessionStorage.setItem("filters", JSON.stringify(filters));

    dispatch("setQueryDisplayed");
  },
  setQueryDisplayed({ commit, rootState }) {
    //generate the query string & displayed array
    console.log(rootState);
    let query = "";
    let displayed = [];
    console.log(state.filters);
    for (let [key, value] of Object.entries(state.filters)) {
      if (value !== null) {
        if (key == "date_field") {
          if (state.filters.start_date || state.filters.end_date) {
            query = query + `&${key}=${value}`;
          }
        } else {
          query = query + `&${key}=${value}`;
          let text = "";
          let fuse = " contains ";

          switch (key) {
            case "start_date":
              text =
                state.filters.date_field == "created_at"
                  ? "Created"
                  : "Updated";
              fuse = " after ";
              break;
            case "end_date":
              text =
                state.filters.date_field == "created_at"
                  ? "Created"
                  : "Updated";
              fuse = " before ";
              break;
            case "domain_status":
              text = key;
              fuse = " is ";
              value = value ? "Active" : "Inactive";
              break;
            case "subdomain_status":
              text = key;
              fuse = " is ";
              value = value ? "Active" : "Inactive";
              break;
            case "url":
              text = key;

              break;
            default:
              text = key;
              break;
          }
          displayed.push({
            label: text + fuse + value,
            id: key,
          });
        }
      }
    }
    console.log(query);
    commit("SET_QUERY", query);
    commit("SET_DISPLAYED", displayed);
  },
};

export const getters = {
  filters: (state) => state.filters,
  displayed: (state) => state.displayed,
};
